import React, { useCallback, useMemo } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { FolderTileProps } from '../types';
import useStyles from './useStyles';
import { formatItemCount } from './utils';

const FolderStoryLayout: React.FC<FolderTileProps> = ({
  id,
  name,
  itemCount = 0,
  onClick,
}) => {
  const classes = useStyles();

  const itemCountText = useMemo(
    () => formatItemCount(itemCount, false),
    [itemCount]
  );

  const truncatedName = useMemo(
    () => ((name?.length ?? 0) > 20 ? `${name!.slice(0, 20)}...` : name),
    [name]
  );

  const onFolderClick = useCallback(() => onClick?.(id), [onClick, id]);

  return (
    <Box
      id={id}
      className={classes.containerHorizontal}
      onClick={onFolderClick}
    >
      <Box className={classes.contentWrapperHorizontal}>
        <Box className={classes.thumbnailHorizontal}>
          <FolderIcon className={classes.folderIcon} />
        </Box>
        <Box className={classes.infoWrapperHorizontal}>
          <Tooltip title={(name?.length ?? 0) > 20 ? name : ''} placement="top">
            <Typography className={classes.name}>{truncatedName}</Typography>
          </Tooltip>
          <Typography className={classes.itemCount}>{itemCountText}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default React.memo(FolderStoryLayout);
